export const ErrorOutlinedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        opacity="0.2"
        d="M16.5 28C23.1274 28 28.5 22.6274 28.5 16C28.5 9.37258 23.1274 4 16.5 4C9.87258 4 4.5 9.37258 4.5 16C4.5 22.6274 9.87258 28 16.5 28Z"
        fill="url(#paint0_linear_10187_50086)"
      />
      <path
        d="M16.5 28C23.1274 28 28.5 22.6274 28.5 16C28.5 9.37258 23.1274 4 16.5 4C9.87258 4 4.5 9.37258 4.5 16C4.5 22.6274 9.87258 28 16.5 28Z"
        stroke="url(#paint1_linear_10187_50086)"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5 17V10"
        stroke="url(#paint2_linear_10187_50086)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 23C17.3284 23 18 22.3284 18 21.5C18 20.6716 17.3284 20 16.5 20C15.6716 20 15 20.6716 15 21.5C15 22.3284 15.6716 23 16.5 23Z"
        fill="url(#paint3_linear_10187_50086)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10187_50086"
          x1="16.5"
          y1="4"
          x2="16.5"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F76A60" />
          <stop offset="1" stopColor="#CF2E22" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10187_50086"
          x1="16.5"
          y1="4"
          x2="16.5"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F76A60" />
          <stop offset="1" stopColor="#CF2E22" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10187_50086"
          x1="17"
          y1="10"
          x2="17"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F76A60" />
          <stop offset="1" stopColor="#CF2E22" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10187_50086"
          x1="16.5"
          y1="20"
          x2="16.5"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F76A60" />
          <stop offset="1" stopColor="#CF2E22" />
        </linearGradient>
      </defs>
    </svg>
  );
};
